exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1 {\n  color: #555;\n  font-size: 2em;\n  font-weight: 400; }\n\npre {\n  text-align: left;\n  margin-top: 2rem; }\n\n@media only screen and (max-width: 280px) {\n  body,\n  p {\n    width: 95%; }\n  h1 {\n    font-size: 1.5em;\n    margin: 0 0 0.3em; } }\n", "", {"version":3,"sources":["/./routes/error/ErrorPage.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB,EAAE;;AAErB;EACE,iBAAiB;EACjB,iBAAiB,EAAE;;AAErB;EACE;;IAEE,WAAW,EAAE;EACf;IACE,iBAAiB;IACjB,kBAAkB,EAAE,EAAE","file":"ErrorPage.scss","sourcesContent":["h1 {\n  color: #555;\n  font-size: 2em;\n  font-weight: 400; }\n\npre {\n  text-align: left;\n  margin-top: 2rem; }\n\n@media only screen and (max-width: 280px) {\n  body,\n  p {\n    width: 95%; }\n  h1 {\n    font-size: 1.5em;\n    margin: 0 0 0.3em; } }\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"modules":true,"localIdentName":"[name]_[local]_[hash:base64:3]","minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./routes/error/ErrorPage.scss
// module id = 69
// module chunks = 0